import React from 'react';
import { NameInitials } from '../../../NameInitials';

interface Props {
  bgColor: string;
  nameStore: string;
}
export const AvatarPerson = ({ bgColor, nameStore }: Props) => {
  return (
    <div
      className="h-100 w-100 flex items-center justify-center"
      style={{ backgroundColor: bgColor }}
    >
      <NameInitials name={nameStore} />
    </div>
  );
};
